import { Symbolizers, GeoPointAdapter, RenderersUtil as Util } from '@leverege/molten/data-viewers';
import { Config } from '@leverege/plugin';
import { Selection } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import Model from "./ZoneVehicleModel.js";
import { getVehiclePointFeature, getVehicleAccuracyFeature } from "./util/index.js";
import { getAccuracy } from "./util/position.js";
export default class ZoneVehicleAdapter extends GeoPointAdapter {
  getShapeData(vehicle, id, options) {
    const {
      model,
      selected,
      rollover
    } = options;
    const positionSource = Attributes.get('positionSource', vehicle.type, vehicle.data);
    const position = Attributes.get('geoPosition', vehicle.type, vehicle.data);
    if (positionSource == null && position == null) {
      return null;
    }
    if (positionSource && positionSource.startsWith('ble')) {
      return {
        dataType: vehicle.type,
        dataRef: vehicle.ref,
        geoJson: getVehiclePointFeature(position),
        appearance: this.getVehicleAppearance(vehicle, options)
      };
    }
    const appearance = this.getVehicleAppearance(vehicle, options);
    const features = [{
      dataType: vehicle.type,
      dataRef: vehicle.ref,
      geoJson: getVehiclePointFeature(position),
      appearance
    }];
    const showAccuracyOn = model && Model.getShowAccuracyOn(model);
    const showAccuracy = showAccuracyOn && (showAccuracyOn === 'always' || showAccuracyOn === 'selected' && Selection.isSelected(selected, vehicle.id) || showAccuracyOn === 'rollover' && Selection.isSelected(rollover, vehicle.id));
    if (showAccuracy) {
      const accuracyMultiplier = Config.get('ZoneVehicleAdapter', 'accuracyMultiplier', 1.2);
      const accuracy = getAccuracy(vehicle, positionSource);
      const accuracyFeature = getVehicleAccuracyFeature(position, accuracy, accuracyMultiplier);
      features.push({
        geoJson: accuracyFeature,
        appearance: this.getAccuracyAppearance(vehicle, options)
      });
    }
    return features;
  }
  getSpread(model) {
    return model && Model.getSpreadRadius(model) && Model.getSpreadRadius(model) / 100 || 0.5;
  }
  getVehicleAppearance(vehicle, {
    rollover,
    selected,
    symbols,
    model
  }) {
    const app = {
      visible: true,
      name: vehicle.name,
      isRollover: Selection.isSelected(rollover, vehicle.id),
      isSelected: Selection.isSelected(selected, vehicle.id),
      showSymbol: true,
      showLabel: false
    };
    app.layerGroup = app.isRollover ? 'rollover' : app.isSelected ? 'selected' : null;
    app.symbol = this.getSymbol(vehicle, {
      app,
      symbols,
      model
    });
    return app;
  }
  getAccuracyAppearance(vehicle, {
    model
  }) {
    const app = {
      visible: true,
      name: `${vehicle.name}.accuracy`,
      showSymbol: false,
      showLabel: false,
      showFill: true
    };
    app.fillColor = app.fillColor == null ? Util.getColor(Model.getFillColor(model), vehicle) : app.fillColor;
    app.fillPattern = app.fillPattern == null ? Util.getPattern(Model.getFillPattern(model), vehicle) : app.fillPattern;
    app.fillOpacity = app.fillOpacity == null ? Util.getNumber(Model.getFillOpacity(model), vehicle) : app.fillOpacity;
    app.lineColor = app.lineColor == null ? Util.getColor(Model.getLineColor(model), vehicle) : app.lineColor;
    app.lineOpacity = app.lineOpacity == null ? Util.getNumber(Model.getLineOpacity(model), vehicle) : app.lineOpacity;
    app.linePattern = app.linePattern == null ? Util.getPattern(Model.getLinePattern(model), vehicle) : app.linePattern;
    app.lineWidth = app.lineWidth == null ? Util.getNumber(Model.getLineWidth(model), vehicle) : app.lineWidth;
    app.lineCap = app.lineCap == null ? Model.getLineCap(model) || 'butt' : app.lineCap;
    app.lineJoin = app.lineJoin == null ? Model.getLineJoin(model) || 'mitre' : app.lineJoin;
    return app;
  }
  getSymbol(vehicle, {
    app,
    model,
    symbols
  }) {
    const subtype = Symbolizers.getSymbol(model.symbolizer, vehicle, null);
    const type = Array.isArray(subtype) && subtype[0] ? subtype[0] : vehicle.type;
    const sType = Array.isArray(subtype) ? subtype[1] : subtype;
    return symbols.getTypeSymbol(type, sType, app.isRollover, app.isSelected);
  }
  getFillPaint(style, layerGroup, options) {
    return {
      'fill-color': ['case', ['has', 'fillColor'], ['get', 'fillColor'], 'rgb(22, 97, 215)'],
      'fill-opacity': ['case', ['has', 'fillOpacity'], ['get', 'fillOpacity'], 0.5]
    };
  }
  getLinePaint(style, layerGroup, options) {
    return {
      'line-color': ['case', ['has', 'lineColor'], ['get', 'lineColor'], 'rgb(22, 97, 215)'],
      'line-width': ['case', ['has', 'lineWidth'], ['get', 'lineWidth'], 1],
      'line-offset': ['case', ['has', 'lineOffset'], ['get', 'lineOffset'], 0],
      'line-opacity': ['case', ['has', 'lineOpacity'], ['get', 'lineOpacity'], 1]
    };
  }
}